import { css } from 'styled-components';

type ModuleMap = {
  [key: number]: {
    [key: number]: string;
  };
};

type Theme = {
  colors: {
    modules: {
      1: {
        [key: number]: string;
      };
      2: {
        [key: number]: string;
      };
      3: {
        [key: number]: string;
      };
      4: {
        [key: number]: string;
      };
    };
  };
};

interface propsType {
  modulo: number,
  color: number,
  theme: Theme,
}

const getModulesType = ({
  modulo,
  color,
  theme,
}: propsType) => {
  const moduleMap: ModuleMap = {
    1: theme.colors.modules[1],
    2: theme.colors.modules[2],
    3: theme.colors.modules[3],
    4: theme.colors.modules[4],
  };

  const moduleColors = moduleMap[modulo];

  if (moduleColors && moduleColors[color]) {
    const background = moduleColors[color];
    return css`
      ${background};
    `;
  }

  // Retorne o estilo padrão ou vazio, dependendo dos requisitos
  return css``;
};

export default getModulesType;
